<template>
  <div style="display: none"></div>
</template>

<script setup lang="ts">
import useApp from '@/hooks/use-app.hooks'

useApp()
</script>
